import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { articles } from '../data/articles';

export default function BlogPage() {
  const { i18n } = useTranslation();
  const isAr = i18n.language === 'ar';

  const sortedArticles = [...articles].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <>
      <SEO
        title={isAr ? 'المدونة | محاكي امتحان PMP' : 'Blog | PMP Exam Simulator'}
        description={isAr ? 'مقالات ونصائح حول امتحان PMP' : 'Articles and tips about the PMP exam'}
        canonical="https://pmpqandanswer.web.app/blog"
      />
      <div className="max-w-5xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
          {isAr ? 'مدونة PMP' : 'PMP Blog'}
        </h1>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          {isAr
            ? 'مقالات وإرشادات متعمقة حول PMBOK 7 و ECO 2026 و Agile لمساعدتك في رحلة التحضير للامتحان.'
            : 'In-depth articles on PMBOK 7, ECO 2026, and Agile to help you on your exam preparation journey.'}
        </p>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {sortedArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="p-6 border border-border rounded-xl bg-card hover:shadow-premium-lg transition-all duration-200 hover:scale-[1.02] block"
            >
              <span className="inline-block px-2.5 py-1 rounded-lg text-xs font-medium bg-primary/10 text-primary mb-3">
                {isAr ? article.tagAr : article.tagEn}
              </span>
              <h2 className="text-lg font-semibold mb-2 leading-snug">
                {isAr ? article.titleAr : article.titleEn}
              </h2>
              <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
                {isAr ? article.excerptAr : article.excerptEn}
              </p>
              <div className="flex items-center justify-between text-xs text-muted-foreground">
                <span>{article.date}</span>
                <span className="text-primary font-medium">
                  {isAr ? `${article.readTime} دقائق` : `${article.readTime} min`}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
